import Paginater from "./Paginater";

export default Paginater;
